import React from 'react';
import { useAuthActions } from '@convex-dev/auth/react';
import { Authenticated, Unauthenticated, AuthLoading } from 'convex/react';
import { Button } from '../ui/button';
import { Card, CardHeader, CardTitle, CardContent } from '../ui/card';

export function TeacherAuth({ children }: { children: React.ReactNode }) {
  return (
    <>
      <AuthLoading>
        <div className="container max-w-md mx-auto px-4 py-8">
          <div className="text-center py-12">
            <p className="text-muted-foreground">Loading...</p>
          </div>
        </div>
      </AuthLoading>
      <Unauthenticated>
        <TeacherSignIn />
      </Unauthenticated>
      <Authenticated>
        {children}
      </Authenticated>
    </>
  );
}

function TeacherSignIn() {
  const { signIn } = useAuthActions();
  const [error, setError] = React.useState<string | null>(null);
  const [isLoading, setIsLoading] = React.useState(false);

  const handleSignIn = async () => {
    try {
      setError(null);
      setIsLoading(true);
      await signIn("github");
    } catch (err) {
      console.error("Sign in error:", err);
      setError(err instanceof Error ? err.message : "Failed to sign in. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container max-w-md mx-auto px-4 py-8">
      <Card>
        <CardHeader>
          <CardTitle>Teacher Login</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-muted-foreground">
            Please sign in with your authorized GitHub account to access the teacher dashboard.
          </p>
          {error && (
            <div className="bg-destructive/10 text-destructive px-4 py-3 rounded border border-destructive/20">
              <p className="text-sm font-medium">Error</p>
              <p className="text-sm">{error}</p>
            </div>
          )}
          <Button 
            onClick={handleSignIn}
            disabled={isLoading}
            className="w-full"
          >
            {isLoading ? "Signing in..." : "Sign in with GitHub"}
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}

export function SignOut() {
  const { signOut } = useAuthActions();
  
  return (
    <Button 
      variant="outline" 
      onClick={() => void signOut()}
    >
      Sign Out
    </Button>
  );
}
